import React from 'react'
import { Route, Switch } from 'react-router'
import ReportTransportInvoicing from './ReportTransportInvoicing'

const Components = props => (
    <Switch>
        <Route exact path={props.match.url} component={ReportTransportInvoicing} />
    </Switch>
)

export default Components
